// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.home-content-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start; /* Changed from center to allow content to grow */
  padding: 5px;
  min-height: 70vh; /* Changed from height to min-height */
  width: 100%;
  flex-wrap: wrap;
}

.item {
  flex: 1 1 100px; /* Flex-grow, flex-shrink, and flex-basis */
  margin: 10px; /* Add some margin for spacing */
}


/* Responsive adjustments */
@media (max-width: 450px) {
  .home-content-container {
    flex-direction: column;
    justify-content: flex-start;
    min-height: 100vh; /* Ensure full viewport height */
    padding-bottom: 200px; /* Extra padding to clear footer */
  }

  .form-container, .image-container {
    min-height: 50vh; /* Adjusted for smaller screens */
    margin: 5px;
    padding: 15px;
  }
}

@media (min-width: 601px) and (max-width: 1024px) {
  .image-container {
    /* height: 60vh; */ /* Removed fixed height */
    min-height: 60vh; /* Use min-height instead */
  }
  .form-container {
    /* height: 60vh; */
    min-height: 60vh;
  }
}

@media (min-width: 1025px) {
  .image-container {
    height: 80vh; /* Adjust height for larger screens */
  }
  .form-container {
    height: 80vh; /* Adjust height for larger screens */
  }
}



.form-container, .image-container {
  flex: 1 1 auto;
  background-color: rgb(255 246 246 / 1%);
  border-radius: 40px;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
  width: auto;
  padding: 20px;
  margin: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 300px; /* Ensure containers have minimum height */
}

#ringForm{
  flex: auto;
}

/* colour options*/
.color-selection-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.color-options {
  display: flex;
  justify-content: center;
  gap: 30px; /* Adds space between color options */
  margin-bottom: 10px;
}

.color-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px; /* Space between color box and description */
}

.color-box {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.2s;
}

.color-box:hover {
  transform: scale(1.1);
}

.color-description {
  font-size: 0.9rem;
  font-weight: 500;
  text-transform: capitalize;
  color: #333;
}

/* 
.color-box#gold-and-platinum {
  background: linear-gradient(180deg, gold 50%, #e5e4e2 50%);
} */



.form-container h6 {
  color: #333;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  text-align: left;
  margin: 0px;
  padding: 5px;
  border: 1px solid #ffffff;
  border-radius: 20px;
  background-color: #fffbfb;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.form-container label {
  margin: 10px 0 5px;
  display: block;
  font-weight: bold;
}

.form-container input[type="color"], .form-container select, .form-container button, .form-container input[type="text"] {
  width: 100%;
  height: 40px; /* Consistent height for alignment */
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 25px;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

.form-container button {
  background-color: #DCC1B5;
  color: rgb(255, 255, 255);
  cursor: pointer;
  border: none;
  font-weight: 600;
  height: 40px; /* Ensure same height as input fields for alignment */
}

.form-container button:hover {
  background-color: #DCC1B5;
}

.side-image {
  text-align: center;
  width: auto;
  object-fit: cover;
  border-radius: 8px;
  max-width: 100%;
  height: 70%;
  padding: 10px;
}


.button-container {
  display: flex;
  justify-content: space-between;
}

.equal-button {
  width: 200px;
  flex: 1 1;
  margin: 5px;
  padding: 10px;
  background-color: #DCC1B5;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
}

.equal-button:hover {
  background-color: #DCC1B5;
}

.link{
  margin: 7px;
}




.shape-selection-container {
  width: 100%;
  max-width: 600px; /* Adjust as needed */
  margin: 0 auto;
  border-radius: 30px;
}

.shape-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; /* Space between items */
}

.shape-box {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 20px); /* 33.333% width minus gap */
  text-align: center;
  padding: 5px;
  box-sizing: border-box;
  cursor: pointer;
  transition: border 0.3s ease;
  border-radius: 10px;
}

.shape-box:hover{border: 3px solid #d6bd7a}



@media (max-width: 320px) {
  .home-content-container {
    height: 60vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/home.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB,EAAE,iDAAiD;EAC1E,YAAY;EACZ,gBAAgB,EAAE,sCAAsC;EACxD,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,2CAA2C;EAC5D,YAAY,EAAE,gCAAgC;AAChD;;;AAGA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB,EAAE,gCAAgC;IACnD,qBAAqB,EAAE,kCAAkC;EAC3D;;EAEA;IACE,gBAAgB,EAAE,iCAAiC;IACnD,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB,EAAE,yBAAyB;IAC7C,gBAAgB,EAAE,2BAA2B;EAC/C;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY,EAAE,qCAAqC;EACrD;EACA;IACE,YAAY,EAAE,qCAAqC;EACrD;AACF;;;;AAIA;EACE,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB,EAAE,0CAA0C;AAC/D;;AAEA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS,EAAE,qCAAqC;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ,EAAE,4CAA4C;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;;;GAGG;;;;AAIH;EACE,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY,EAAE,oCAAoC;EAClD,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY,EAAE,qDAAqD;AACrE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;;;;AAKA;EACE,WAAW;EACX,gBAAgB,EAAE,qBAAqB;EACvC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAE,wBAAwB;AACrC;;AAEA;EACE,YAA8B;EAA9B,cAA8B;EAA9B,gCAA8B,EAAE,4BAA4B;EAC5D,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,iBAAiB,yBAAyB;;;;AAI1C;EACE;IACE,YAAY;EACd;AACF","sourcesContent":["\n.home-content-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start; /* Changed from center to allow content to grow */\n  padding: 5px;\n  min-height: 70vh; /* Changed from height to min-height */\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.item {\n  flex: 1 1 100px; /* Flex-grow, flex-shrink, and flex-basis */\n  margin: 10px; /* Add some margin for spacing */\n}\n\n\n/* Responsive adjustments */\n@media (max-width: 450px) {\n  .home-content-container {\n    flex-direction: column;\n    justify-content: flex-start;\n    min-height: 100vh; /* Ensure full viewport height */\n    padding-bottom: 200px; /* Extra padding to clear footer */\n  }\n\n  .form-container, .image-container {\n    min-height: 50vh; /* Adjusted for smaller screens */\n    margin: 5px;\n    padding: 15px;\n  }\n}\n\n@media (min-width: 601px) and (max-width: 1024px) {\n  .image-container {\n    /* height: 60vh; */ /* Removed fixed height */\n    min-height: 60vh; /* Use min-height instead */\n  }\n  .form-container {\n    /* height: 60vh; */\n    min-height: 60vh;\n  }\n}\n\n@media (min-width: 1025px) {\n  .image-container {\n    height: 80vh; /* Adjust height for larger screens */\n  }\n  .form-container {\n    height: 80vh; /* Adjust height for larger screens */\n  }\n}\n\n\n\n.form-container, .image-container {\n  flex: 1 1 auto;\n  background-color: rgb(255 246 246 / 1%);\n  border-radius: 40px;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);\n  width: auto;\n  padding: 20px;\n  margin: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px; /* Ensure containers have minimum height */\n}\n\n#ringForm{\n  flex: auto;\n}\n\n/* colour options*/\n.color-selection-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.color-options {\n  display: flex;\n  justify-content: center;\n  gap: 30px; /* Adds space between color options */\n  margin-bottom: 10px;\n}\n\n.color-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px; /* Space between color box and description */\n}\n\n.color-box {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.color-box:hover {\n  transform: scale(1.1);\n}\n\n.color-description {\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-transform: capitalize;\n  color: #333;\n}\n\n/* \n.color-box#gold-and-platinum {\n  background: linear-gradient(180deg, gold 50%, #e5e4e2 50%);\n} */\n\n\n\n.form-container h6 {\n  color: #333;\n  font-family: Arial, sans-serif;\n  font-size: 15px;\n  font-weight: bold;\n  text-align: left;\n  margin: 0px;\n  padding: 5px;\n  border: 1px solid #ffffff;\n  border-radius: 20px;\n  background-color: #fffbfb;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n}\n\n.form-container label {\n  margin: 10px 0 5px;\n  display: block;\n  font-weight: bold;\n}\n\n.form-container input[type=\"color\"], .form-container select, .form-container button, .form-container input[type=\"text\"] {\n  width: 100%;\n  height: 40px; /* Consistent height for alignment */\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 25px;\n  box-sizing: border-box;\n  font-family: 'Poppins', sans-serif;\n}\n\n.form-container button {\n  background-color: #DCC1B5;\n  color: rgb(255, 255, 255);\n  cursor: pointer;\n  border: none;\n  font-weight: 600;\n  height: 40px; /* Ensure same height as input fields for alignment */\n}\n\n.form-container button:hover {\n  background-color: #DCC1B5;\n}\n\n.side-image {\n  text-align: center;\n  width: auto;\n  object-fit: cover;\n  border-radius: 8px;\n  max-width: 100%;\n  height: 70%;\n  padding: 10px;\n}\n\n\n.button-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.equal-button {\n  width: 200px;\n  flex: 1;\n  margin: 5px;\n  padding: 10px;\n  background-color: #DCC1B5;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  text-align: center;\n  font-family: 'Poppins', sans-serif;\n  font-size: 16px;\n}\n\n.equal-button:hover {\n  background-color: #DCC1B5;\n}\n\n.link{\n  margin: 7px;\n}\n\n\n\n\n.shape-selection-container {\n  width: 100%;\n  max-width: 600px; /* Adjust as needed */\n  margin: 0 auto;\n  border-radius: 30px;\n}\n\n.shape-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px; /* Space between items */\n}\n\n.shape-box {\n  flex: 1 1 calc(33.333% - 20px); /* 33.333% width minus gap */\n  text-align: center;\n  padding: 5px;\n  box-sizing: border-box;\n  cursor: pointer;\n  transition: border 0.3s ease;\n  border-radius: 10px;\n}\n\n.shape-box:hover{border: 3px solid #d6bd7a}\n\n\n\n@media (max-width: 320px) {\n  .home-content-container {\n    height: 60vh;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
